import React, { useEffect } from "react"
import { Spinner } from "reactstrap";
import {
  Row,
  Col
} from "reactstrap"

import { Link } from "react-router-dom"
import i18n from '../../i18n'

const Spinners = ({ setLoading }) => {

    useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 1000)
    }, [setLoading]);
    return (
        <React.Fragment>
          {/* <Spinner color="primary" className='position-absolute top-50 start-50' /> */}
          <Row>
            <Col xs="12">
              <div className="text-center my-3">
                <Link to="#" className="text-success">
                  <i className="bx bx-loader bx-spin font-size-18 align-middle me-2" />
                  {i18n.t("Loading...")}
                </Link>
              </div>
            </Col>
          </Row>
        </React.Fragment>
    )
}

export default Spinners;